// @flow
/* globals Promise:true, tableau */
import { connect } from 'react-redux';
import styles from './App.css';
import Snackbar from 'material-ui/Snackbar';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/RaisedButton';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import {Card, CardActions, CardHeader, CardText, TextField} from 'material-ui/Card';
import lizardLogo from '../images/appicons/lizard@3x.svg';
import moment from 'moment';
import React, { Component, PropTypes } from 'react';
import $ from 'jquery';

// import {} from '../actions.jsx';

let myConnector;

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pis: [],
      events: [],
      username: '',
      password: '',
    };
    this._getData = this._getData.bind(this);
  }

  componentDidMount() {

    myConnector = tableau.makeConnector();

    // myConnector.getSchema = (schemaCallback) => {
    //   const cols = [
    //     {
    //       id: 'region_name',
    //       dataType: tableau.dataTypeEnum.string,
    //     },
    //     {
    //       id: 'date',
    //       dataType: tableau.dataTypeEnum.string,
    //     },
    //     {
    //       id: 'score',
    //       dataType: tableau.dataTypeEnum.float,
    //     },
    //     {
    //       id: 'value',
    //       dataType: tableau.dataTypeEnum.float,
    //     },
    //   ];
    //
    //   const tableInfo = {
    //     id: 'lizardTimeseries',
    //     alias: 'Timeseries from Lizard API',
    //     columns: cols,
    //   };
    //   schemaCallback([tableInfo]);
    // };

    myConnector.getSchema = (schemaCallback) => {
      const cols = [
        {
          id: 'date',
          dataType: tableau.dataTypeEnum.date,
        },
        {
          id: 'value',
          dataType: tableau.dataTypeEnum.float,
        },
      ];

      const tableInfo = {
        id: 'lizardTimeseries',
        alias: 'Timeseries from Lizard API',
        columns: cols,
      };
      schemaCallback([tableInfo]);
    };

    myConnector.getData = (table, doneCallback) => {
      this._getData(table, doneCallback);
    };
    tableau.registerConnector(myConnector);
    //   $.ajax({
    //     dataType: 'json',
    //     url: '/api/v2/pi/12/',
    //     success: (data) => {
    //       let tableData = [];
    //       tableData = data.regions.map((region) => {
    //         return region.aggregations.map((aggregation) => {
    //           return {
    //             'region_name': region.region_name,
    //             'date': aggregation.date,
    //             'score': aggregation.score,
    //             'value': aggregation.value,
    //           };
    //         });
    //       });
    //       tableData = [].concat.apply([], tableData);
    //       tableau.log(tableData);
    //       table.appendRows(tableData);
    //       doneCallback();
    //     },
    //   });
    // };
    //
    // tableau.registerConnector(myConnector);

  }

  componentWillUnmount() {}

  shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(this.props, nextProps) ||
     !_.isEqual(this.state, nextState);
  }

  componentWillReceiveProps(newProps) {}

  _getData(table, doneCallback) {
    $.ajax({
      dataType: 'json',
      // url: `https://${this.state.username}:${this.state.password}@crossorigin.me/https://${this.state.username}:${this.state.password}@wdodelta.lizard.net/api/v2/timeseries/?end=1476560937162&min_points=320&start=1475325828507&uuid=2f43e1d8-0242-482e-acd7-ada1e825e9f4&page_size=0`,
      url: 'https://cors-anywhere.herokuapp.com/https://wdodelta.lizard.net/api/v2/timeseries/?end=1476560937162&min_points=320&start=1475325828507&uuid=2f43e1d8-0242-482e-acd7-ada1e825e9f4&page_size=0',
      success: (data) => {
        let tableData = [];
        tableData = data[0].events.map((event) => {
          return {'date': moment(event.timestamp).format('M/d/YYYY HH:mm:ss'), 'value': event.value};
        });
        tableau.log(tableData);
        table.appendRows(tableData);
        doneCallback();
      },
    });
  }

  render() {
    const pis = (this.state.pis.length > 0) ?
        <div>
        {
          this.state.pis.map((pi) => {
            return <div>{pi.id}</div>;
          })
        }
        </div> : '';

    return (
      <div>
        <img className={styles.LizardLogo} src={lizardLogo} />

        {(this.state.pis.length > 0) ?
            pis : ''
        }

        {(this.state.pis.length === 0 && this.state.events.length === 0) ?
          <Card>
            <CardHeader
              title='Lizard x Tableau'
              subtitle='Met deze connector kunt u data vanuit de Lizard API koppelen met uw Tableau dashboards. Kies hieronder een databron:'
              actAsExpander={true}
              showExpandableButton={false}
            />
            <CardText expandable={false}>
            <div className={styles.Datasources}>

            <form>
              <label htmlFor="lz-user">Lizard gebruikersnaam</label>
              <input
                type="text"
                id="lz-user"
                name="lzUser"
                className={styles.InputText}
                onChange={(e) => {
                  this.setState({
                    username: e.target.value,
                  });
                }}
              />

              <label htmlFor="lname">Lizard password</label>
              <input
                type="password"
                id="lz-pass"
                name="lzPass"
                className={styles.InputText}
                onChange={(e) => {
                  this.setState({
                    password: e.target.value,
                  });
                }}
              />
            </form>

              <input type='radio'
                     name='datasource'
                     id='1'
                     value='events'
                     onClick={(e) => {
                      //  $.ajax({
                      //    dataType: 'json',
                      //    url: '/api/v2/events/?event_series__name__iexact=overstorting&geom_within=POLYGON((5.189151763916016%2052.36317907250486,5.189151763916016%2052.37046386084771,5.206060409545898%2052.37046386084771,5.206060409545898%2052.36317907250486,5.189151763916016%2052.36317907250486))&page_size=0',
                      //    success: (data) => {
                      //      tableau.log('----->', data);
                      //      this.setState({
                      //        events: data.map((d) => {
                      //          return {
                      //            id: d.id,
                      //          };
                      //        }),
                      //      });
                      //    },
                      //  });
                     }} />
              <label htmlFor={'1'}>&nbsp;Tijdseries</label>
              <br/>
              <input type='radio'
                     name='datasource'
                     id='2'
                     value='pi'
                     onClick={(e) => {
                      //  $.ajax({
                      //    dataType: 'json',
                      //    url: '/api/v2/pi/?page_size=0',
                      //    success: (data) => {
                      //      this.setState({
                      //        pis: data.map((d) => {
                      //          return {
                      //            id: d.id,
                      //            name: d.name,
                      //            url: d.url,
                      //            reference_value: d.reference_value,
                      //            normalised_by: d.normalised_by,
                      //          };
                      //        }),
                      //      });
                      //    },
                      //  });
                     }} />
              <label htmlFor={'2'}>&nbsp;Performance Indicators</label>

            </div>
            </CardText>
            <RaisedButton
              disabled={(this.state.username.length > 1 && this.state.password.length > 1) ? false : true}
              onClick={() => {
                tableau.connectionName = 'Lizard API';
                tableau.submit();
              }}
              primary={true}
              label='Data ophalen'
              fullWidth={true}
            />
          </Card>
          : ''
        }
      </div>
    );
  }
}

App.propTypes = {};

function mapStateToProps(state) {
  // This function maps the Redux state to React Props.
  return {};
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./components/App.jsx